import { ShimmerFollowingUserListLoading } from "components/app/shrimmer/Shrimmer";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RootState } from "store/store";

import useMarketPlacesStore from "store/useMarketPlacesStore";
import Layout from "layout/layout";
import WelcomePage from "pages/welcome/welcome-page/WelcomePage";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import { Skeleton } from "components/ui/skeleton";
import ImageUrlThumbnail from "components/app/image-url/ImageUrlThumbnail";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Tabs, TabsList, TabsTrigger } from "components/ui/tabs";
import { AppLog } from "services";
import { StatusMsg } from "utils";
import { Breadcrumb, BreadcrumbItem, BreadcrumbLink, BreadcrumbList, BreadcrumbPage, BreadcrumbSeparator } from "components/ui/breadcrumb";
import { Link } from "react-router-dom";
import LocationPopover from "./components/LocationPopover";
import SortPopover from "./components/SortPopover";
import PricePopover from "./components/PricePopover";
import ProductShopToggle from "./components/ProductShopToggle";
import NewFeedRightSidebar from "components/app/new-feed-post/NewFeedRightSidebar";
import { Button } from "components/ui/button";
import { Card } from "components/ui/card";
import { ChevronLeft, ChevronRight } from "lucide-react";
import ProductGrid from "./components/ProductGrid";

const categories = [
  {
    id: 1,
    description: "Cars and Vehicles",
    thumbnail: "https://images.khmer24.co/categories/23-01-17/s-cars-and-vehicles-1673926803.png",
    sub_items: [
      {
        id: 1,
        description: "Cars for sale",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-cars-for-sale-1638864308.png",
      },
      {
        id: 2,
        description: "Bicycles",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-bicycles-1638864338.png",
      },
      {
        id: 3,
        description: "Motorcycles for Sale",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-motorcycles-for-sale-1638864345.png",
      },
      {
        id: 4,
        description: "Vehicles for Rent",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-vehicles-for-rent-1638864353.png",
      },
      {
        id: 5,
        description: "Maintenance & Repair",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-car-maintenance-repair-1638864358.png",
      },
      {
        id: 6,
        description: "Lorries, Vans & Tractors",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-lorries-vans-and-tractors-1638864364.png",
      },
      {
        id: 7,
        description: "Financing & INsurance",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-financing-insurance-1638864370.png",
      },
      {
        id: 8,
        description: "Tuk Tuk & Remork",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-tuk-tuk-and-remork-1638864378.png",
      },
      {
        id: 9,
        description: "Parts & Accessories",
        thumbnail: "https://images.khmer24.co/categories/21-10-25/s-car-parts-accessories-1635125149.png",
      },
      {
        id: 10,
        description: "Others",
        thumbnail: "https://images.khmer24.co/categories/21-10-27/s-others-vihicles-1635300275.png",
      },
    ],
  },
  {
    id: 2,
    description: "Phones & Tablets",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-mobile-phones-tablets-1638848154.png",
    sub_items: [
      {
        id: 1,
        description: "Phones",
        thumbnail: "https://images.khmer24.co/categories/21-11-04/s-phones-1635998098.png",
      },
      {
        id: 2,
        description: "Tablets",
        thumbnail: "https://images.khmer24.co/categories/21-11-04/s-tablets-1635998033.png",
      },
      {
        id: 3,
        description: "Smart Watches",
        thumbnail: "https://images.khmer24.co/categories/21-11-02/s-smart-watches-1635818860.png",
      },
      {
        id: 4,
        description: "Accessories",
        thumbnail: "https://images.khmer24.co/categories/21-10-22/s-phone-accessories-1634875697.png",
      },
      {
        id: 5,
        description: "Phone Numbers",
        thumbnail: "https://images.khmer24.co/categories/21-11-02/s-phone-numbers-1635818003.png",
      },
    ],
  },
  {
    id: 3,
    description: "Computers & Accessories",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-computer-and-accessories-1638848160.png",
    sub_items: [
      {
        id: 1,
        description: "Laptops",
        thumbnail: "https://images.khmer24.co/categories/21-12-07/s-laptops-1638864565.png",
      },
      {
        id: 2,
        description: "Desktops",
        thumbnail: "https://images.khmer24.co/categories/21-12-08/s-desktops-1638927496.png",
      },
      {
        id: 3,
        description: "All-In-One",
        thumbnail: "https://images.khmer24.co/categories/21-12-08/s-all-in-one-pc-1638927503.png",
      },
      {
        id: 4,
        description: "Monitors",
        thumbnail: "https://images.khmer24.co/categories/21-12-08/s-monitors-1638927508.png",
      },
      {
        id: 5,
        description: "Printers & Scanners",
        thumbnail: "https://images.khmer24.co/categories/21-12-08/s-printers-and-scanners-1638927513.png",
      },
      {
        id: 6,
        description: "Parts & Accessories",
        thumbnail: "https://images.khmer24.co/categories/21-12-08/s-computer-parts-and-accessories-1638927519.png",
      },
      {
        id: 7,
        description: "Softwares",
        thumbnail: "https://images.khmer24.co/categories/21-12-08/s-softwares-1638927558.png",
      },
    ],
  },
  {
    id: 4,
    description: "Electronics & Appliances",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-electronics-appliances-1638848165.png",
    sub_items: [],
  },
  {
    id: 5,
    description: "House & Lands",
    thumbnail: "https://images.khmer24.co/categories/23-09-21/s-property-housing-rentals-1695265714.png",
    sub_items: [
      {
        id: 1,
        description: "Hourse for Sale",
        thumbnail: "https://images.khmer24.co/categories/21-12-29/s-house-for-sale-1640752236.png",
      },
      {
        id: 2,
        description: "House for Rent",
        thumbnail: "https://images.khmer24.co/categories/21-12-30/s-house-for-rent-1640838860.png",
      },
      {
        id: 3,
        description: "Condo for Sale",
        thumbnail: "https://images.khmer24.co/categories/21-12-30/s-condo-for-sale-1640838868.png",
      },
      {
        id: 4,
        description: "Apartment for Rent",
        thumbnail: "https://images.khmer24.co/categories/21-12-30/s-apartment-for-rent-1640838875.png",
      },
      {
        id: 5,
        description: "Land for Sale",
        thumbnail: "https://images.khmer24.co/categories/21-10-27/s-land-for-sale-1635319589.png",
      },
      {
        id: 6,
        description: "Land for Rent",
        thumbnail: "https://images.khmer24.co/categories/21-11-04/s-land-for-rent-1636020760.png",
      },
      {
        id: 7,
        description: "Commercial for sale",
        thumbnail: "https://images.khmer24.co/categories/21-11-04/s-commercial-properties-for-sale-1636019636.png",
      },
      {
        id: 8,
        description: "Commercial for Rent",
        thumbnail: "https://images.khmer24.co/categories/21-12-30/s-commercial-properties-for-rent-1640838885.png",
      },
      {
        id: 9,
        description: "Room for Rent",
        thumbnail: "https://images.khmer24.co/categories/21-10-27/s-room-for-rent-1635322825.png",
      },
      {
        id: 10,
        description: "Properties Wanted",
        thumbnail: "https://images.khmer24.co/categories/21-10-27/s-properties-wanted-1635324689.png",
      },
      {
        id: 11,
        description: "Agent Services",
        thumbnail: "https://images.khmer24.co/categories/21-10-20/s-agent-services-1634722141.png",
      },
      {
        id: 12,
        description: "Others",
        thumbnail: "https://images.khmer24.co/categories/21-10-27/s-others-properties-1635316937.png",
      },
    ],
  },
  {
    id: 6,
    description: "Jobs",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-jobs-1638848186.png",
    sub_items: [],
  },
  {
    id: 7,
    description: "Services",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-services-1638848194.png",
    sub_items: [],
  },
  {
    id: 8,
    description: "Fashion & Beauty",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-fashion-beauty-1638848200.png",
    sub_items: [],
  },
  {
    id: 9,
    description: "Furniture & Decor",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-furniture-decor-1638848206.png",
    sub_items: [],
  },
  {
    id: 10,
    description: "Books, Sports & Hobbies",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-books-sports-hobbies-1638848212.png",
    sub_items: [],
  },
  {
    id: 11,
    description: "Pets",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-pets-1638848219.png",
    sub_items: [],
  },
  {
    id: 12,
    description: "Foods",
    thumbnail: "https://images.khmer24.co/categories/21-12-07/s-foods-1638848268.png",
    sub_items: [],
  },
];

const locations = [
  {
    name: "Phnom Penh",
    children: ["Boeng Keng Kang", "Chamkar Mon", "Chbar Ampov", "Chrouy Changva", "Dangkao", "Doun Penh", "Kamboul"],
  },
  {
    name: "Siem Reap",
    children: ["Svay Dangkum", "Sala Kamreuk"],
  },
  {
    name: "Kampot",
    children: [],
  },
];

export default function MarketPlaces() {
  const isAuthenticated = useSelector((state: RootState) => state.auth.isAuthenticated);

  const { appRecord, initializePage, disposePage } = useMarketPlacesStore();

  const [selectedType, setSelectedType] = useState<string>("product");
  const [selectedCategory, setSelectedCategory] = useState<any>(null);

  const [activeLocation, setActiveLocation] = useState<string | null>(null);
  const current = locations.find((loc) => loc.name === activeLocation);

  const onClickedCategory = async (category: any) => {
    try {
      if (selectedCategory && selectedCategory?.id === category.id) {
        setSelectedCategory(null);
      } else {
        setSelectedCategory(category);
      }
    } catch (error) {
      AppLog.show({
        message: `[onClickedCategory]`,
        status: StatusMsg.error,
        error,
      });
    }
  };

  useEffect(() => {
    initializePage();

    return () => {
      disposePage();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {isAuthenticated ? (
        <div className="container-wrapper w-full">
          <div className="container px-4 sm:px-6 lg:px-8 mx-auto">
            <div className="py-6 space-y-2">
              {/* Navigate */}
              <div className="pt-2 pb-2">
                <Breadcrumb>
                  <BreadcrumbList>
                    <BreadcrumbItem>
                      <BreadcrumbLink>
                        <Link to="#">Product</Link>
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbLink>
                        <Link to="#">{selectedCategory?.description}</Link>
                      </BreadcrumbLink>
                    </BreadcrumbItem>
                    <BreadcrumbSeparator />
                    <BreadcrumbItem>
                      <BreadcrumbPage>Phone</BreadcrumbPage>
                    </BreadcrumbItem>
                  </BreadcrumbList>
                </Breadcrumb>
              </div>

              {/* Categories */}
              {!selectedCategory && (
                <div className="w-full rounded-lg bg-muted/50 p-4 space-y-4">
                  <div className="flex flex-wrap gap-2 sm:flex-nowrap sm:overflow-x-auto">
                    <ProductShopToggle />
                  </div>

                  <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-9 xl:grid-cols-10 gap-4">
                    {categories.map((category: any, index: number) => (
                      <div key={index} className="flex flex-col items-center space-y-2" onClick={() => onClickedCategory(category)}>
                        <Card
                          className="
                      w-16 h-16 
                      p-1 

                      sm:w-16 sm:h-16 
                      sm:p-1 

                      md:w-20 md:h-20
                      md:p-1

                      lg:w-20 lg:h-20
                      lg:p-1

                      xl:w-20 xl:h-20 
                      xl:p-3 

                      rounded-full border border-border flex items-center justify-center transition"
                        >
                          <img src={category.thumbnail} alt={category.description} className="w-full h-full object-contain" />
                        </Card>
                        <span className="text-xs font-medium text-center max-w-[80px] leading-tight line-clamp-2">{category.description}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              {selectedCategory && (
                <div className="w-full rounded-lg bg-muted/50 p-4 space-y-4">
                  <div className="flex flex-wrap gap-2 sm:flex-nowrap sm:overflow-x-auto">
                    <Button
                      variant="outline"
                      size="icon"
                      onClick={() => {
                        setSelectedCategory(null);
                      }}
                    >
                      <ChevronLeft />
                    </Button>
                    <LocationPopover />
                    <SortPopover />
                    <PricePopover />
                  </div>

                  <div className="grid grid-cols-4 sm:grid-cols-5 md:grid-cols-6 lg:grid-cols-9 xl:grid-cols-10 gap-4">
                    {selectedCategory.sub_items.map((subCategory: any, index: number) => (
                      <div key={index} className="flex flex-col items-center space-y-2" onClick={() => {}}>
                        <Card
                          className="
                      w-16 h-16 
                      p-1 

                      sm:w-16 sm:h-16 
                      sm:p-1 

                      md:w-20 md:h-20
                      md:p-1

                      lg:w-20 lg:h-20
                      lg:p-1

                      xl:w-20 xl:h-20 
                      xl:p-3 

                      rounded-full border border-border flex items-center justify-center transition"
                        >
                          <img src={subCategory.thumbnail} alt={subCategory.description} className="w-full h-full object-contain" />
                        </Card>
                        <span className="text-xs font-medium text-center max-w-[80px] leading-tight line-clamp-2">{subCategory.description}</span>
                      </div>
                    ))}
                  </div>
                </div>
              )}

              <div className="gap-10 my-10">Banner</div>

              <ProductGrid />
            </div>
          </div>
        </div>
      ) : (
        <WelcomePage />
      )}
    </>
  );
}
